/* ==========================================================================
   f1-rho-cart.js  (R9)
   Behavior for the Rho-style cart drawer:
     - "Add" buttons on the "You'll love these too" upsell cards add a product
       to the cart WITHOUT navigating away, then refresh the native drawer via
       Dawn's own <cart-drawer>.renderContents() section-render path.
   Does NOT modify Dawn's core cart-drawer.js. Pure event delegation on
   document so it survives the AJAX section re-renders Dawn performs on the
   drawer (the upsell buttons are recreated on every cart update).
   ========================================================================== */
(function () {
  'use strict';

  var ADD_SELECTOR = '[data-f1-upsell-add]';

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function addUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add';
  }

  function fetchCfg() {
    // Mirror Dawn's fetchConfig if present; otherwise a safe default.
    if (typeof window.fetchConfig === 'function') {
      return window.fetchConfig('javascript');
    }
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
    };
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.classList.toggle('is-loading', busy);
    button.disabled = busy;
  }

  function addToCart(button) {
    var variantId = button && button.getAttribute('data-variant-id');
    if (!variantId) return;

    var cartDrawer = getCartDrawer();
    setBusy(button, true);

    var body = {
      items: [{ id: Number(variantId), quantity: 1 }],
    };

    // Ask Shopify to re-render the drawer sections in the same response so we
    // can hand them straight to Dawn's renderContents (no second round-trip).
    if (cartDrawer) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }

    var cfg = fetchCfg();

    fetch(addUrl(), Object.assign({}, cfg, { body: JSON.stringify(body) }))
      .then(function (response) {
        return response.json();
      })
      .then(function (parsedState) {
        if (parsedState && parsedState.status) {
          // Shopify returned an error object (e.g. sold out). Bail quietly.
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState.sections) {
          cartDrawer.renderContents(parsedState);
        } else {
          // Fallback: notify any cart subscribers to re-fetch + re-render.
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'f1-rho-cart',
              cartData: parsedState,
            });
          }
          if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
        }
      })
      .catch(function (e) {
        // Defensive: never throw into the page. Leave the drawer as-is.
        if (window.console) console.error('[f1-rho-cart] add failed', e);
      })
      .finally(function () {
        // The button may have been replaced by the section re-render; guard.
        setBusy(button, false);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest(ADD_SELECTOR) : null;
    if (!button) return;
    event.preventDefault();
    addToCart(button);
  });
})();
